import { render, staticRenderFns } from "./UtilAccordianItem.vue?vue&type=template&id=85bd0754"
import script from "./UtilAccordianItem.vue?vue&type=script&lang=js"
export * from "./UtilAccordianItem.vue?vue&type=script&lang=js"
import style0 from "./UtilAccordianItem.vue?vue&type=style&index=0&id=85bd0754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports